// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import { IoIosArrowDown } from "react-icons/io";
// import { NavLink, useLocation } from "react-router-dom";

// const SubMenu = ({ data, isSelected, onClick }) => {
//   const { pathname } = useLocation();
//   const [subMenuOpen, setSubMenuOpen] = useState(false);


//   console.log("subMenuOpen",subMenuOpen)
//   return (
//     <>
//       <li
//         className={`link ${isSelected ? "text-red-500" : ""} ${
//           pathname.includes(data.name) && "text-blue-600"
//         }`}
//         onClick={() => {
//           onClick(data.name);
//           setSubMenuOpen(!subMenuOpen);
//         }}
//       >
//         <data.icon size={23} className="min-w-max" />
//         <p className="flex-1 capitalize">{data.name}</p>
//         <IoIosArrowDown
//           className={` ${subMenuOpen && "rotate-180"} duration-200 `}
//         />
//       </li>
//       <motion.ul
//         animate={
//           subMenuOpen
//             ? {
//                 height: "fit-content",
//               }
//             : {
//                 height: 0,
//               }
//         }
//         className="flex h-0 flex-col pl-14 text-[0.8rem] font-normal overflow-hidden"
//       >
//         {data.menus?.map((menu) => (
//           <li key={menu}>
//             <NavLink
//               to={`/${data.name}/${menu}`}
//               className={`link capitalize ${
//                 isSelected && pathname.includes(menu) ? "text-red-500" : ""
//               }`}
//             >
//               {menu}
//             </NavLink>
//           </li>
//         ))}
//       </motion.ul>
//     </>
//   );
// };

// export default SubMenu;
import React, { useState } from "react";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import {  IoIosArrowForward } from "react-icons/io";

const SubMenu = ({ data, isSelected, onClick }) => {
  const { pathname } = useLocation();
  const [subMenuOpen, setSubMenuOpen] = useState(false);

  return (
    <>
      <li
        className={`link ${isSelected ? "text-red-500" : ""} ${
          pathname.includes(data.name) && "text-blue-600"
        }`}
        onClick={() => {
          onClick(data.name);
          setSubMenuOpen(!subMenuOpen);
        }}
      >
        <data.icon size={23} className="min-w-max" />
        <p className="flex-1 capitalize">{data.name}</p>
        <IoIosArrowForward
          className={` ${subMenuOpen && "rotate-90"} duration-200 `}
          style={{ fontSize: "18px" }}
        />
      </li>
      <ul
        className={`submenu ${subMenuOpen ? "open" : "closed"}`}
      >
        {data.menus?.map((menu) => (
          <li key={menu}>
            <NavLink
              to={`/${data.name}/${menu}`}
              className="link capitalize"
            >
              {menu}
            </NavLink>
          </li>
        ))}
      </ul>
      {/* <motion.ul
        animate={
          subMenuOpen
            ? {
                height: "fit-content",
              }
            : {
                height: 0,
              }
        }
        className="flex flex-col text-[0.8rem] font-normal overflow-hidden"
      >
        {data.menus?.map((menu) => (
          <li key={menu} style={{ marginBottom: "5px"}} >
            <NavLink
              to={`/${data.name}/${menu}`}
              className={`link capitalize ${
                isSelected && pathname.includes(menu) ? "text-red-500" : ""
              }`}
            >
              {menu}
            </NavLink>
          </li>
        ))}
      </motion.ul> */}
    </>
  );
};

export default SubMenu;
